import { configureStore } from '@reduxjs/toolkit';
import partnerReducer from '../slices/partnerSlice';
import sessionReducer from '../slices/sessionSlice';
import partnershipReducer from '../slices/partnershipSlice';

export const store = configureStore({
  reducer: {
    partnership: partnershipReducer,
    session: sessionReducer,
    partner: partnerReducer,
  },
});